import React, { useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import { ModalContext } from '../../../contexts/ModalContext';
import AdmActionTable from '../../AdmActionTable';
import { MODAL_ADM_ACTIONS } from '../../modals/constants';

const AdmActionsModal = (props) => {
  const context = useContext(ModalContext);
  const modalProps = context.openModalProps[MODAL_ADM_ACTIONS];
  const isOpen = context.isModalOpen(MODAL_ADM_ACTIONS);
  if (isOpen && modalProps) {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={'xl'}
        open={isOpen}
        onClose={() => context.closeModal(MODAL_ADM_ACTIONS)}
        disableEnforceFocus={true}
      >
        <AdmActionTable
          data={modalProps.data}
          title={`${modalProps.related_type} Activity`}
          relatedId={modalProps.related_id}
          relatedType={modalProps.related_type}
          newActionCallback={modalProps.newActionCallback}
          showAddButton={modalProps.showAddButton}
        />
      </Dialog>
    );
  } else {
    return null;
  }
};

export default AdmActionsModal;
